




























import { Component, Mixins, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { __ } from 'bits/intl'
import { IntlMixin } from 'vuemixins/intl_mixin'
import BaseIcon from 'vuecomponents/base_icon.vue'
import BaseButtonIcon from 'library/v4/components/base-button-icon.vue'

const browser = namespace('browser')
const EXTENSION_URL = 'https://chrome.google.com/webstore/detail/padlet-mini/kcljbbiddpoeaknnjaminoceoojdbikp'

@Component({
  components: {
    BaseIcon,
    BaseButtonIcon,
  },
})
export default class Dropdown extends Mixins(IntlMixin) {
  @Prop() title!: string
  @Prop() items!: Object[]
  @browser.State os
  isOpen = false
  chromeExtensionUrl = EXTENSION_URL

  openMenu(e) {
    e.stopPropagation()
    this.isOpen = !this.isOpen
  }

  get isOsSupported(): boolean {
    return this.os !== 'unknown'
  }

  get installAppUrl(): string | undefined {
    if (this.os === 'ios') return 'https://padlet.com/ios-app'
    if (this.os === 'android') return 'https://padlet.com/android-app'
    if (this.os === 'windows') return 'https://www.microsoft.com/en-us/p/padlet/9mtwd1kmhb48'
    if (this.os === 'mac') return 'https://downloads.padletcdn.com/Padlet.dmg'
    return undefined
  }

  get installAppText(): string | undefined {
    if (this.os === 'ios') return __('Install iOS app')
    if (this.os === 'android') return __('Install android app')
    if (this.os === 'windows') return __('Install windows app')
    if (this.os === 'mac') return __('Install mac app')
    return undefined
  }
}
